import React, { useState, useEffect } from "react";
import "./imgCabe.css";
import apiClient from '../../acciones/apiClient';

export const ImgCabecera = () => {
    const [imgSrc, setImgSrc] = useState(null);

    useEffect(() => {
        const fetchImgPrincipal = async () => {
            try {
                const response = await apiClient.get("/imgPrincipal");
                if (response.data && response.data.imgPrinci) {
                    setImgSrc(response.data.imgPrinci);
                } else {
                    console.error("No se encontró una imagen principal en el servidor.");
                }
            } catch (error) {
                console.error("Error al obtener la imagen principal:", error);
            }
        };

        fetchImgPrincipal();
    }, []);

    return (
        <div className="image-container">
            {imgSrc ? (
                <img src={imgSrc} alt="Imagen principal" className="imgCabecera" />
            ) : (
                <p>Cargando imagen...</p>
            )}
        </div>
    );
};
